import { styled } from '@mui/material/styles'
import { DataGridPro } from '@mui/x-data-grid-pro'

export const RequirementsDataGrid = styled(DataGridPro, {
  name: 'RequirementsDataGrid',
  slot: 'Root',
  skipSx: true,
  skipVariantsResolver: true,
})`
  .MuiDataGrid-cell:focus {
    outline: none;
  }
  .MuiDataGrid-cell:focus-within {
    outline: none;
  }
  .MuiDataGrid-columnHeader {
    font-family: 'Source Sans Pro Semibold';
  }
`
